import { doc, setDoc, increment } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Incrémente le compteur de lectures `views` du billet `evangile_<lang>/<date>`.
 *
 * - Ignoré pour les navigateurs automatisés (Playwright/Selenium) via `navigator.webdriver`.
 * - Dédupliqué par navigateur + billet via `localStorage` : un même navigateur ne compte
 *   qu'une fois par billet (approxime des lecteurs uniques, évite le gonflage au rechargement).
 * - Les erreurs sont avalées : le comptage ne doit jamais casser l'affichage.
 *
 * @returns `true` si un incrément a réellement été envoyé (utile pour un affichage optimiste).
 */
export const incrementEvangileView = async (lang: string, date: string): Promise<boolean> => {
  if (typeof navigator !== 'undefined' && navigator.webdriver) return false;
  if (!lang || !date) return false;

  const storageKey = `ev_viewed_${lang}_${date}`;
  try {
    if (localStorage.getItem(storageKey)) return false;
  } catch {
    // localStorage indisponible (mode privé strict) → on tente quand même l'incrément
  }

  try {
    await setDoc(
      doc(db, `evangile_${lang}`, date),
      { views: increment(1) },
      { merge: true }
    );
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      // ignore
    }
    return true;
  } catch (err) {
    console.error('[evangileViews] increment failed:', err);
    return false;
  }
};
